'use client';

import { Typography, Link } from '@mui/material';
import { useWidgetBrandColors } from './useWidgetBrandColors';

interface PoweredByCapioProps {
  /**
   * Font size for the text. Can be a number (px) or a string.
   * @default 10
   */
  fontSize?: number | string;
  /**
   * Text alignment
   * @default 'center'
   */
  textAlign?: 'left' | 'center' | 'right';
  /**
   * Additional CSS properties
   */
  sx?: Record<string, unknown>;
}

/**
 * Reusable component for displaying "Powered by Capio" branding.
 * Always displays the text with a link to https://www.capio.ai/
 */
export function PoweredByCapio({ fontSize = 10, textAlign = 'center', sx = {} }: PoweredByCapioProps) {
  const { primaryOnPaper } = useWidgetBrandColors();

  return (
    <Typography
      component="span"
      sx={{
        color: 'text.disabled',
        fontSize,
        textAlign,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        ...sx,
      }}
    >
      Powered by{' '}
      <Link
        aria-label="Powered by Capio (opens in a new tab)"
        href="https://www.capio.ai/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: primaryOnPaper,
          textDecoration: 'none',
          fontWeight: 600,
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        Capio
      </Link>
    </Typography>
  );
}
